import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import hi from "i18n-iso-countries/langs/hi.json";

countries.registerLocale(en);
countries.registerLocale(hi);

/* WORLD COUNTRIES */
export const getCountryOptions = (language) => {
  const names = countries.getNames(language ? "hi" : "en", {
    select: "official",
  });

  return Object.values(names).map((name) => ({
    label: name,
    value: name,
  }));
};
